export default __webpack_public_path__ + "static/media/IMG_1969.0f3b49a5.JPG";